var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { cx } from 'linaria';
export function withFlightUI(Component, _a) {
    var { as, theme, className: cls, styles, unstyled } = _a, rest = __rest(_a, ["as", "theme", "className", "styles", "unstyled"]);
    const className = typeof cls === 'function' ? cls(theme) : cls;
    const baseStyles = unstyled || !styles ? null : styles(theme);
    return React.createElement(as, Object.assign({ className: cx(baseStyles, className) }, rest), Component);
}
//# sourceMappingURL=withFlightUI.js.map